import { render } from "./Paintings.vue?vue&type=template&id=314275a6"
import script from "./Paintings.vue?vue&type=script&lang=js"
export * from "./Paintings.vue?vue&type=script&lang=js"

import "./Paintings.vue?vue&type=style&index=0&id=314275a6&lang=css"

import exportComponent from "D:\\Code_projects\\maria_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__